import AccountAvatarUploadModule from './account-avatar-upload.module'

export default AccountAvatarUploadModule
